/**
 * Afterpay modal x cart drawer fix.
 *
 * The cart drawer is a <dialog> opened with showModal(), which puts it in the
 * browser top layer. Afterpay's on-site messaging appends <afterpay-modal> to
 * <body>, so the modal paints UNDER the drawer and is inert (unclickable)
 * while the drawer is open. Users could only dismiss it by clicking what they
 * thought was the X, which actually hit the dialog backdrop and closed the
 * cart instead.
 *
 * Fix: while the drawer is open and the Afterpay modal becomes visible, move
 * the modal element inside the drawer's <dialog> so it joins the top-layer
 * subtree and paints above the drawer. Two containing-block traps must be
 * neutralised while it's adopted, or the modal's position:fixed overlay gets
 * confined to the drawer box instead of the viewport:
 *   1. the dialog's `move-and-fade` animation keeps a transform applied
 *   2. <header-component> (the drawer's ancestor) has `contain: layout style`
 * Both are restored, and the modal returned to <body>, as soon as it closes.
 * Clicks inside the modal retarget to the <afterpay-modal> host, which is now
 * inside the dialog, so the drawer's light-dismiss no longer fires. Afterpay's
 * own overlay-click-to-close works again because the modal is no longer inert.
 */
(function () {
  var restore = null;

  function openDrawerDialog() {
    var dialog = document.querySelector('cart-drawer-component dialog[open]');
    try {
      return dialog && dialog.matches(':modal') ? dialog : null;
    } catch (e) {
      return dialog;
    }
  }

  function adopt(modal) {
    var dialog = openDrawerDialog();
    if (!dialog || dialog.contains(modal) || restore) return;

    var header = dialog.closest('header-component');
    var placeholder = document.createComment('afterpay-modal-home');
    modal.parentNode.insertBefore(placeholder, modal);

    var prevAnimation = dialog.style.animation;
    var prevContain = header ? header.style.contain : '';
    dialog.appendChild(modal);
    dialog.style.animation = 'none';
    if (header) header.style.contain = 'none';

    var release = function () {
      restore = null;
      dialog.removeEventListener('close', release);
      dialog.style.animation = prevAnimation;
      if (header) header.style.contain = prevContain;
      if (placeholder.parentNode) {
        placeholder.parentNode.insertBefore(modal, placeholder);
        placeholder.remove();
      } else {
        document.body.appendChild(modal);
      }
    };
    // Safety net: if the drawer somehow closes while adopted, put things back.
    dialog.addEventListener('close', release);
    restore = release;
  }

  function overlayOf(modal) {
    return modal.shadowRoot && modal.shadowRoot.querySelector('.afterpay-modal-overlay');
  }

  function watch(modal) {
    var overlay = overlayOf(modal);
    if (!overlay) return false;

    new MutationObserver(function () {
      if (overlay.classList.contains('visible')) {
        adopt(modal);
      } else if (restore) {
        // Defer past the in-flight click that closed the modal: restoring
        // synchronously moves the modal out of the dialog mid-dispatch, so the
        // drawer's click handlers would re-evaluate the target as "outside".
        setTimeout(function () {
          if (restore) restore();
        }, 0);
      }
    }).observe(overlay, { attributes: true, attributeFilter: ['class'] });

    // ESC should close only the Afterpay modal, not the cart drawer.
    document.addEventListener(
      'keydown',
      function (event) {
        if (event.key !== 'Escape') return;
        if (!overlay.classList.contains('visible') || !restore) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        var close = modal.shadowRoot.querySelector('#afterpay-modal-close-button');
        if (close) close.click();
      },
      true
    );
    return true;
  }

  function init() {
    var modal = document.querySelector('afterpay-modal');
    return modal ? watch(modal) : false;
  }

  if (!init()) {
    var observer = new MutationObserver(function () {
      if (init()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
